<div [formGroup]="aFormControl()" class="flex flex-column pb1">
  <div formArrayName="date-parts" class="flex items-center col-12">
    @for (parts of dateParts.controls; track parts; let i = $index) {
      <div class="flex items-center flex-auto date-form-field">
        @if (i > 0) {
          <div class="mx2">
            <span class="mat-body-2 text-muted">to</span>
          </div>
        }

        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{ i === 0 ? (schema()?.title || 'Date') : 'End Date' }}</mat-label>
          <input
            matInput
            type="text"
            [value]="getDatePartsAsString(i)"
            (input)="updateDatePartsFromString(i, $event)"
            [placeholder]="i === 0 ? 'Enter start date' : 'Enter end date'"
          />
          @if (schema()?.description && i === 0) {
            <mat-hint>{{ schema()?.description }}</mat-hint>
          }
        </mat-form-field>

        @if (i > 0) {
          <button
            type="button"
            mat-icon-button
            color="warn"
            (click)="removeDateParts(i)"
            matTooltip="Remove end date"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    }

    @if (dateParts.length < 2) {
      <button
        type="button"
        mat-icon-button
        color="primary"
        (click)="addDateParts()"
        matTooltip="Add end date for date range"
      >
        <mat-icon>add</mat-icon>
      </button>
    }
  </div>

  @if (shouldShowErrors()) {
    <div class="col-12 pt3">
      <small>{{ getErrorMessage() }}</small>
    </div>
  }
</div>
